import styled from 'styled-components'

import { theme } from '../../../styles/theme'

export const SelectionsContainer = styled.div`
  width: 100%;
  margin-top: -8px;

  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`

export const Selection = styled.div`
  padding: 4px 12px;

  background-color: ${theme.colors.gray100};
  border-radius: ${theme.border.smallRadius};

  color: ${theme.colors.gray800};
  font-size: ${theme.font.sizes.small};
  font-weight: ${theme.font.normal};

  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    width: 8px;
    height: 8px;

    path {
      fill: ${theme.colors.gray800};
    }

    &:hover {
      cursor: pointer;
    }
  }
`
